"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaBlockMetadataToJSON = exports.RosettaBlockMetadataFromJSONTyped = exports.RosettaBlockMetadataFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaBlockMetadataFromJSON(json) {
    return RosettaBlockMetadataFromJSONTyped(json, false);
}
exports.RosettaBlockMetadataFromJSON = RosettaBlockMetadataFromJSON;
function RosettaBlockMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'memo': !runtime_1.exists(json, 'memo') ? undefined : json['memo'],
        'size': !runtime_1.exists(json, 'size') ? undefined : json['size'],
        'lockTime': !runtime_1.exists(json, 'lockTime') ? undefined : json['lockTime'],
    };
}
exports.RosettaBlockMetadataFromJSONTyped = RosettaBlockMetadataFromJSONTyped;
function RosettaBlockMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'memo': value.memo,
        'size': value.size,
        'lockTime': value.lockTime,
    };
}
exports.RosettaBlockMetadataToJSON = RosettaBlockMetadataToJSON;
//# sourceMappingURL=RosettaBlockMetadata.js.map